/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { CellPresenterBase } from "./CellPresenterBase";
import { CellModel } from "./CellModel";
import { EditorCellModel } from "./EditorCellModel";
import { markType } from "igniteui-react-core";
import { stringIsNullOrWhiteSpace } from "igniteui-react-core";
/**
 * @hidden
 */
var EditorCellPresenter = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(EditorCellPresenter, _super);
    function EditorCellPresenter(a) {
        return _super.call(this, a) || this;
    }
    Object.defineProperty(EditorCellPresenter.prototype, "d", {
        get: function () {
            return this.a;
        },
        enumerable: true,
        configurable: true
    });
    EditorCellPresenter.prototype.b = function (a) {
        _super.prototype.b.call(this, a);
        var b = a;
        if (b.ar) {
            if (b.aw(EditorCellModel.ku) || b.aw(EditorCellModel.ks) || b.aw(EditorCellModel.kt) || b.aw(EditorCellModel.kv)) {
                this.d.b8 = b.km;
                this.d.c0 = b.k2;
                this.d.c4 = b.k8;
                this.d.b4 = b.kg;
            }
            if (b.aw(EditorCellModel.kr)) {
                this.d.b6 = b.ki;
            }
            if (b.aw(EditorCellModel.kx)) {
                this.d.c1 = b.k3;
            }
            if (b.aw(EditorCellModel.kw)) {
                this.d.dq(b.kk == null);
            }
            if (b.aw(CellModel.et)) {
                this.d.ce = b.af;
            }
            if (b.aw(EditorCellModel.ky)) {
                if (stringIsNullOrWhiteSpace(b.le)) {
                    this.d.ch = false;
                    this.d.db();
                }
                else {
                    this.d.ch = true;
                    this.d.ds(b.le, b.b7, b.b8, b.f8, b.ev);
                }
            }
        }
    };
    EditorCellPresenter.$t = markType(EditorCellPresenter, 'EditorCellPresenter', CellPresenterBase.$);
    return EditorCellPresenter;
}(CellPresenterBase));
export { EditorCellPresenter };
//# sourceMappingURL=EditorCellPresenter.js.map
